/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LabelsConfig
 */
export interface LabelsConfig {
    /**
     * 
     * @type {Array<string>}
     * @memberof LabelsConfig
     */
    add?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LabelsConfig
     */
    remove?: Array<string>;
}

export function LabelsConfigFromJSON(json: any): LabelsConfig {
    return LabelsConfigFromJSONTyped(json, false);
}

export function LabelsConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): LabelsConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'add': !exists(json, 'add') ? undefined : json['add'],
        'remove': !exists(json, 'remove') ? undefined : json['remove'],
    };
}

export function LabelsConfigToJSON(value?: LabelsConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'add': value.add,
        'remove': value.remove,
    };
}

